"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const ProductContentVideoSaga_1 = tslib_1.__importDefault(require("../../productContentVideo/sagas/ProductContentVideoSaga"));
const loadProductContentVideoeModule = () => ({
    id: 'ProductContentVideos',
    sagas: [ProductContentVideoSaga_1.default],
});
exports.default = loadProductContentVideoeModule;
